import { Pipe, PipeTransform } from '@angular/core';
import { WithdrawRialStatus } from '../../../../shared/models/withdraw.model';

@Pipe({
  name: 'withdrawStatus'
})
export class WithdrawStatusPipe implements PipeTransform {
  transform(value: WithdrawRialStatus, ...args: unknown[]): string {
    if (value === 'PENDING') {
      return 'در حال بررسی';
    }
    if (value === WithdrawRialStatus.SUCCESSFUL) {
      return 'انجام شده';
    }
    if (value === WithdrawRialStatus.CHECKED_BY_OPERATOR) {
      return 'بررسی گردید';
    }
    if (value === WithdrawRialStatus.FAILED) {
      return 'لفو شده';
    }
    if (value === WithdrawRialStatus.ERROR) {
      return 'خطا';
    }
    return '';
  }
}
